import React from 'react';
import { Spin } from 'antd';
import './GiroSpin.less';

interface GiroSpinProps {
  size?: 'small' | 'medium' | 'large';
  spinning?: boolean;
  children?: React.ReactNode;
  tip?: string;
  animationType?: 'circle' | 'pulse' | 'dots';
}

const GiroSpin: React.FC<GiroSpinProps> = ({
  size = 'medium',
  spinning = true,
  children,
  tip,
  animationType = 'circle'
}) => {
  const getSizeStyle = () => {
    switch (size) {
      case 'small':
        return {
          icon: { width: 16, height: 24 },
          circle: { width: 32, height: 32 }
        };
      case 'large':
        return {
          icon: { width: 52, height: 80 },
          circle: { width: 100, height: 100 }
        };
      default:
        return {
          icon: { width: 26, height: 40 },
          circle: { width: 60, height: 60 }
        };
    }
  };

  const getCircleClassName = () => {
    switch (animationType) {
      case 'pulse':
        return 'giro-spin-circle giro-spin-circle-pulse';
      case 'dots':
        return 'giro-spin-circle giro-spin-circle-dots';
      default:
        return 'giro-spin-circle';
    }
  };

  const sizes = getSizeStyle();

  const customIndicator = (
    <div className="giro-spin-container">
      <div className="giro-spin-wrapper">
        <svg
          className="giro-spin-icon"
          style={sizes.icon}
          viewBox="0 0 26 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.0647736 0.0316467H1.9218L9.9055 7.03988H25.4708V40H23.6138L15.6301 32.9918H0.0647736V0.0316467Z"
            fill="#258BF6"
          />
          <path
            d="M0 0L25.4077 39.9684H23.549L15.5653 32.9601H0V0Z"
            fill="#0C72E5"
          />
        </svg>
        <div
          className={getCircleClassName()}
          style={sizes.circle}
        />
      </div>
      {tip && <div className="giro-spin-tip">{tip}</div>}
    </div>
  );

  return (
    <Spin
      indicator={customIndicator}
      spinning={spinning}
      size={size}
    >
      {children}
    </Spin>
  );
};

export default GiroSpin;
